import React from 'react';
import { ArrowRight, Trash2 } from 'lucide-react';
import { getCollegeName } from './designSystem';
import AIUpdateIcon from './AIUpdateIcon';

/**
 * SchoolCard - Refined design with slate/stone base and minimal color
 * Small color dot indicator only, typography-focused
 */
const SchoolCard = ({
  college,
  index = 0,
  category,
  children,
  onClick,
  showCategory = true,
  showArrow = false,
  aiUpdate = null, // { onClick, tooltip, isLoading }
  onDelete = null // Delete handler function
}) => {
  const collegeName = getCollegeName(college);

  // Color dots for visual variety (small pops only)
  const dotColors = [
    'bg-indigo-500',
    'bg-violet-500',
    'bg-teal-500',
    'bg-amber-500'
  ];
  const dotColor = dotColors[index % dotColors.length];

  return (
    <div
      className="group relative bg-white border-2 border-slate-300 rounded-xl overflow-hidden transition-all duration-200 hover:border-slate-900 hover:shadow-lg cursor-pointer"
      onClick={onClick}
    >
      <div className="p-6">
        {/* Header with category and color dot */}
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-2">
            {/* Small color dot indicator */}
            <div className={`w-2 h-2 rounded-full ${dotColor} flex-shrink-0`} />
            {showCategory && category && (
              <span className="text-xs font-bold text-slate-500 tracking-wider uppercase">
                {category}
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            {showArrow && (
              <button className="text-slate-700 hover:text-slate-900 transition-colors">
                <ArrowRight className="w-5 h-5" />
              </button>
            )}
            {onDelete && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`Remove ${collegeName} from your list?`)) {
                    onDelete(college.id);
                  }
                }}
                className="opacity-0 group-hover:opacity-100 transition-opacity p-1.5 hover:bg-red-50 rounded-full"
                title="Delete college"
              >
                <Trash2 className="w-4 h-4 text-red-600" />
              </button>
            )}
          </div>
        </div>

        {/* College Name - Typography emphasis */}
        <div className="flex items-center gap-2 mb-6">
          <h3 className="text-xl font-bold text-slate-900">
            {collegeName}
          </h3>
          {aiUpdate && (
            <AIUpdateIcon
              tooltip={aiUpdate.tooltip}
              onClick={aiUpdate.onClick}
              isLoading={aiUpdate.isLoading}
            />
          )}
        </div>

        {/* Children content (custom content for each card) */}
        {children}
      </div>
    </div>
  );
};

export default SchoolCard;
